import { createStandardAction } from 'typesafe-actions';
import type { SearchEngine } from 'SearchEngine-Types';

export const setSearchEngine = createStandardAction('SET_SEARCH_ENGINE').map(
  (payload: SearchEngine) => ({
    payload,
  }),
);
